import { withLazyFallback } from 'lib/hoc/withLazyFallback';

const CommsCenter = withLazyFallback(() => import('components/practice/comms_center/CommsCenter'));
const ContactsPage = withLazyFallback(
  () => import('components/practice/comms_center/Contacts/ContactsPage')
);
const NewArchivedFaxes = withLazyFallback(
  () => import('components/practice/comms_center/fax/ArchivedFaxes/NewArchivedFaxes')
);

const DraftFaxes = withLazyFallback(
  () => import('components/practice/comms_center/fax/Drafts/DraftFaxes')
);
const Fax = withLazyFallback(() => import('components/practice/comms_center/fax/Fax/Fax'));
const NewInboundFaxes = withLazyFallback(
  () => import('components/practice/comms_center/fax/InboundFaxes/NewInboundFaxes')
);
const Main = withLazyFallback(() => import('components/practice/comms_center/fax/Main/Main'));
const NewOutboundFaxes = withLazyFallback(
  () => import('components/practice/comms_center/fax/OutboundFaxes/NewOutboundFaxes')
);

const PRACTICE_COMMS_CENTER = [
  {
    path: 'comms-center',
    element: <CommsCenter />,
    handle: { title: 'Comms Center' },
    children: [
      {
        path: '',
        element: <Fax />,
        handle: { title: 'Fax' },
        children: [
          { path: '', element: <Main /> },
          { path: 'inbound', element: <NewInboundFaxes />, handle: { title: 'Inbound' } },
          { path: 'outbound', element: <NewOutboundFaxes />, handle: { title: 'Outbound' } },
          { path: 'drafts', element: <DraftFaxes />, handle: { title: 'Drafts' } },
          { path: 'Archived', element: <NewArchivedFaxes />, handle: { title: 'Archived' } }
        ]
      },
      { path: 'contacts', element: <ContactsPage />, handle: { title: 'Contacts' } }
    ]
  }
];

export default PRACTICE_COMMS_CENTER;
